

import ContractPF from './PF/ContractPF';
import ContractPM from './PM/ContractPM';
import { Document } from '@react-pdf/renderer';

export const RootLayout = ({ data, isPF }) => {
    // Determine type from data if isPF is not explicitly provided
    const determinedType = data?.legalRep?.nombre || data?.guarantor?.nombre ? 'PM' : 'PF';
    const finalIsPF = isPF !== undefined ? isPF : (determinedType === 'PF');
    const finalType = finalIsPF ? 'PF' : 'PM';

    return <Document>
        {finalIsPF ? <ContractPF data={data} type={finalType} /> : <ContractPM data={data} type={finalType} />}
    </Document>
};